<template>
  <div id="" class="">
    <div class="topbar" data-dropdown="dropdown" id="mytopbar">
      <div class="topbar-inner" style="background-image: none">
        <div class="customerlogo">
          <a :href="mainUrl" title="Inicio">
            <span></span>
          </a>
        </div>

        <ul class="nav nav-right">
          <li>
          </li>

          <li>
          </li>

          <li class="top-languages" id="languageSelector">
            <language-login :lang="this.lang"></language-login>
          </li>
        </ul>

      </div>
      <!-- /topbar-inner -->
    </div>
    <!-- /topbar -->
  </div>
</template>

<script>
import {currentLang, domain} from "../../config";
import LanguageLogin from "./LanguageLogin";
import Ihsvg from "../common/Ihsvg";

export default {
  name: "TopbarLogin",
  data() {
    return {
      name: '',
      lang: currentLang
    }
  },
  components: {
    LanguageLogin,
    Ihsvg
  },

  mounted() {
  },
  computed: {
    mainUrl: () => domain
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// TopbarLogin.vue?08118593